import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import StorageUpdateModal from './StorageUpdateModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  storage: state.storage,
  status: state.modal.storageUpdateModal
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_STORAGE_UPDATE, false),
  updateStorageFile: actions.storage.updateStorageFile,
  setTable: actions.storage.setTable
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StorageUpdateModal)



// WEBPACK FOOTER //
// ./src/components/Modals/StorageUpdateModal/index.js